export var ConnectorTaskType;
(function (ConnectorTaskType) {
    ConnectorTaskType["GITHUB_LIST_REPOSITORIES"] = "github.listRepositories";
    ConnectorTaskType["GITHUB_SEARCH"] = "github.search";
    ConnectorTaskType["GITHUB_GET_ISSUE"] = "github.getIssue";
    ConnectorTaskType["GITHUB_GET_PULL_REQUEST"] = "github.getPullRequest";
    ConnectorTaskType["GITHUB_GET_REPOSITORY"] = "github.getRepository";
    ConnectorTaskType["GITHUB_CREATE_ISSUE"] = "github.createIssue";
    ConnectorTaskType["GITHUB_ADD_COMMENT"] = "github.addComment";
    ConnectorTaskType["GITHUB_UPDATE_ISSUE"] = "github.updateIssue";
    ConnectorTaskType["GITHUB_TRANSITION_ISSUE"] = "github.transitionIssue";
    ConnectorTaskType["GITHUB_GET_COMMENTS"] = "github.getComments";
    ConnectorTaskType["GITHUB_GET_FILE_CONTENT"] = "github.getFileContent";
    ConnectorTaskType["GITHUB_GET_TREE"] = "github.getTree";
    ConnectorTaskType["GITHUB_GET_PULL_REQUEST_DIFF"] = "github.getPullRequestDiff";
    ConnectorTaskType["JIRA_LIST_PROJECTS"] = "jira.listProjects";
    ConnectorTaskType["JIRA_GET_ISSUE"] = "jira.getIssue";
    ConnectorTaskType["JIRA_SEARCH_ISSUES"] = "jira.searchIssues";
    ConnectorTaskType["JIRA_LIST_PROJECT_MEMBERS"] = "jira.listProjectMembers";
    ConnectorTaskType["JIRA_LIST_SPRINTS"] = "jira.listSprints";
    ConnectorTaskType["JIRA_ADD_COMMENT"] = "jira.addComment";
    ConnectorTaskType["JIRA_GET_COMMENTS"] = "jira.getComments";
    ConnectorTaskType["JIRA_CREATE_ISSUE"] = "jira.createIssue";
    ConnectorTaskType["JIRA_CREATE_SPRINT"] = "jira.createSprint";
    ConnectorTaskType["JIRA_MOVE_ISSUES_TO_SPRINT"] = "jira.moveIssuesToSprint";
    ConnectorTaskType["JIRA_DECOMPOSE_EPIC"] = "jira.decomposeEpic";
    ConnectorTaskType["JIRA_UPDATE_ISSUE"] = "jira.updateIssue";
    ConnectorTaskType["JIRA_TRANSITION_ISSUE"] = "jira.transitionIssue";
    ConnectorTaskType["JIRA_ASSIGN_ISSUE"] = "jira.assignIssue";
    ConnectorTaskType["JIRA_LINK_ISSUES"] = "jira.linkIssues";
    ConnectorTaskType["CONFLUENCE_LIST_SPACES"] = "confluence.listSpaces";
    ConnectorTaskType["CONFLUENCE_SEARCH"] = "confluence.search";
    ConnectorTaskType["CONFLUENCE_GET_PAGE"] = "confluence.getPage";
    ConnectorTaskType["CONFLUENCE_CREATE_PAGE"] = "confluence.createPage";
    ConnectorTaskType["CONFLUENCE_UPDATE_PAGE"] = "confluence.updatePage";
})(ConnectorTaskType || (ConnectorTaskType = {}));
//# sourceMappingURL=connector-task-type.enum.js.map